import React from 'react';
import PropTypes from 'prop-types';
import createStyles from "../createStyles";
import TextField from "../TextField";
import Row from "../Layout/Row";
import * as flags from "./flags";
export var useStyles = createStyles(function () {
  return {
    root: {
      height: '25px',
      width: '25px'
    }
  };
});

var PhonePickerDropdownItem = function PhonePickerDropdownItem(_ref) {
  var jss = _ref.jss,
      country = _ref.country;
  var classes = useStyles({
    jss: jss
  });
  var name = country.name;
  var CountryIcon = flags[country.iso2.toUpperCase()];
  return /*#__PURE__*/React.createElement(Row, {
    spacing: 2,
    align: "center",
    "data-qa": "phone-picker-dropdown-item"
  }, /*#__PURE__*/React.createElement(CountryIcon, {
    className: classes.root
  }), /*#__PURE__*/React.createElement(TextField, null, name));
};

PhonePickerDropdownItem.propTypes = {
  country: PropTypes.PropTypes.shape()
};
export default PhonePickerDropdownItem;